import type * as React from 'react';

import {
    Button,
    Description,
    EmptyState,
    EmptyStateAccessDeniedHeader,
    EmptyStateActions,
} from '@gitbook/spine-react';

/**
 * Full-screen component when the user can't access a change request
 */
export function ChangeRequestNotAuthorized(): React.ReactElement {
    return (
        <EmptyState>
            <EmptyStateAccessDeniedHeader />
            <Description>
                You don't have permissions to access this change request. Contact the organization
                administrator to configure access.
            </Description>
            <EmptyStateActions>
                <Button
                    kind="secondary"
                    size="medium"
                    href={{
                        current: {
                            changeRequest: undefined,
                            sideSheet: { type: 'change-requests' },
                        },
                    }}
                    label="View change requests"
                />
            </EmptyStateActions>
        </EmptyState>
    );
}
